require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-code-a-veterans-take-on-learning-to-code-at-code-fellows.json") })
        }
      }, "path---blog-why-code-a-veterans-take-on-learning-to-code-at-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-code-a-veterans-take-on-learning-to-code-at-code-fellows!./.cache/json/blog-why-code-a-veterans-take-on-learning-to-code-at-code-fellows.json
// module id = 1162
// module chunks = 231608221292675